import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

const useSyncAuthAcrossTabs = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const handleStorageChange = (event) => {
      if (event.key === "access_token") {
       
        if (event.newValue) {
          navigate("/");
        } 
        else {
          navigate("/login");
        }
      }
    };

    window.addEventListener("storage", handleStorageChange);
    return () => window.removeEventListener("storage", handleStorageChange);
  }, [navigate]);
};

export default useSyncAuthAcrossTabs;
